export default {"src":"/_next/static/media/badge-appstore-zh.c4368659.svg","height":40,"width":109,"blurWidth":0,"blurHeight":0};